import React, { FC } from "react";
import { Box, Divider } from "@mui/material";
import { PropertiesCard } from "shared-ts-ui-properties-card";
import {
  Chimney,
  ChimneyUpdateSpec,
} from "firefly-my-chimney-ts-building";
import { useTranslation } from "react-i18next";
import { CustomerEnvironmentId } from "firefly-shared-ts-customer-environment";
import { ChimneyForm } from "./ChimneyForm";
import { Property } from "shared-ts-property";

export interface ChimneyPanelProps {
  environment: CustomerEnvironmentId;
  chimney: Chimney;
  onChange: (update: ChimneyUpdateSpec) => void;
}

export const ChimneyPanel: FC<ChimneyPanelProps> = (props) => {
  const { chimney, environment } = props;
  const { t: tFireflyDomain } = useTranslation("firefly-shared-ts-domain");
  const { t } = useTranslation("my-chimney-ts-translations");

  return (
    <Box>
      <PropertiesCard
        header={{
          title: `${t("Chimney")}${
            chimney.mcFields?.name != null
              ? `: ${chimney.mcFields?.name ?? ""}`
              : ""
          }`,
          subtitle: t(
            "The fire department has recorded the following information about the chimney"
          ),
        }}
        elevation={0}
      >
        <Property
          label={tFireflyDomain("Chimney Hat")}
          value={tFireflyDomain(`ChimneyHat.${chimney.fields.hat}`)}
        />
      </PropertiesCard>
      {chimney.mcFields != null && (
        <>
          <Divider />
          <ChimneyForm
            chimney={chimney}
            environment={environment}
            onChange={props.onChange}
          />
        </>
      )}
    </Box>
  );
};
